/* @flow */
import { ActionTypes } from 'constants/InvitationConstants';
import { dispatcher } from 'lib/Dispatcher';
import Invitations from 'collections/Invitations';

const InvitationActions = {
  invite(groupId: number, recipients: mixed[]) {
    dispatcher.dispatch({
      type: ActionTypes.CREATE_INVITATION,
      recipients,
    });

    return Invitations.invite(groupId, recipients);
  },
};

export default InvitationActions;



// WEBPACK FOOTER //
// ./src/groups/actions/InvitationActions.js